import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Hardscaping from "@/pages/Hardscaping";
import SnowRemoval from "@/pages/SnowRemoval";
import LawnMaintenance from "@/pages/LawnMaintenance";
import OutdoorKitchens from "@/pages/OutdoorKitchens";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

const AppShell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="App min-h-screen bg-bone">
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hardscaping" element={<Hardscaping />} />
          <Route path="/snow-removal" element={<SnowRemoval />} />
          <Route path="/lawn-maintenance" element={<LawnMaintenance />} />
          <Route path="/outdoor-kitchens" element={<OutdoorKitchens />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
